<template>
  <div id="main-div" class="projects-page" @click="hideYearLengends()">
    <ControlPanel v-show="!hidePanelAndFooter"/>
    <div class="img-container" id="img-container" @click="hidePanel()">
      <div id="points">
        <CityImageContainer></CityImageContainer>
      </div>
    </div>
    <div :class="`projects-header ${(state.movileView ? '':'header-hide')}`">
      <div class="controls">
        <HelpPanel class="participa-help-panel" v-show="state.movileView"/>
      </div>
    </div>
    <transition name="fade">
      <SummaryPanel class="summary" v-show="state.movileView || !hidePanelAndFooter"/>
    </transition>
    <Footer class="footer" v-show="!hidePanelAndFooter"/>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex'
import resize from '@/mixins/resize.js'

export default {
  mixins: [resize],
  mounted () {
    this.setInterfaceForMobile()

    if (!this.isMobile) {
      this.hidePanelAndFooter = !this.hidePanelAndFooter
    }
  },

  components: {
    Footer: _ => import('@/components/Footer'),
    CityImageContainer: _ => import('@/components/projects/CityImageContainer'),
    HelpPanel: _ => import('@/components/projects/HelpPanel'),
    SummaryPanel: _ => import('@/components/projects/SummaryPanel')
  },

  data () {
    return {
      hidePanelAndFooter: true
    }
  },

  watch: {
    isMobile (newValue) {
      if (newValue) this.setInterfaceForMobile()
    },

    isLandscape (newValue) {
      if (newValue) this.setInterfaceForMobile()
    },

    getProjectInfo (projectInfo) {
      if (!projectInfo) return
      this.setProjectInfoAndUpdateRoute({ projectInfo })
    }
  },

  computed: {
    ...mapGetters(['getProjectInfo']),
    ...mapGetters({
      state: 'interfaceState'
    })
  },

  methods: {
    ...mapActions([ 'reset', 'desactivateControl', 'toggle', 'hideYearLengends', 'setProjectInfoAndUpdateRoute' ]),
    /**
     * This method center the scroll to an desired position
     *
     * In this case, the position is `targetX` and `targetY`, change that to match
     * the current target.
     */
    initScroll () {
      const targetX = 0
      const targetY = 100

      document.getElementById('img-container').scrollLeft = targetX
      document.getElementById('img-container').scrollTop = targetY
    },

    hidePanel () {
      if (this.isMobile) {
        this.hidePanelAndFooter = !this.hidePanelAndFooter
      }
    },

    hideHeader () {
      this.desactivateControl('movileView')

      const list = document.getElementsByClassName('filter-by-years')
      for (let i = 0; i < list.length; i++) {
        list[i].style.top = '10px'
      }
    },

    setInterfaceForMobile () {
      setTimeout(() => {
        this.initScroll()
      }, 100)
      this.reset()

      if (this.isMobile) {
        setTimeout(this.hideHeader, 5000)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.projects-page {
  .control-link {
    .asu-title {
      background-color: rgba(255, 255, 255, .6)
    }
  }
}
</style>

<style lang="stylus">
@import '~@/styles/variables'

.projects-page {
  #main-div {
    position: fixed;
    top: 0;
    left: 0;
  }

  #points {
    position: absolute;
    left: 0;
    top: 0;
    width: 1920px;
    height: 1080px;
    min-width: 100vmax;
    min-width: 100vw;
    min-height: 100vmin;
    min-height: 100vh;
    overflow-y: auto;
    overflow-x: auto;
  }

  .img-container {
    position: absolute;
    overflow: auto;
    width: 100vmax;
    width: 100vw;
    height: 100vmin;
    height: 100vh;
    max-width: 100vmax;
    max-width: 100vw;
    min-width: 100vmax;
    min-width: 100vw;
    max-height: 100vmin;
    max-height: 100vh;
    min-height: 100vmin;
    min-height: 100vh;
    overflow-x: auto;
    overflow-y: auto;
  }

  .projects-header {
    position: fixed;
    width: $min-widthVMAX;
    width: $min-widthVW;
    top: 0;
  }

  .projects-header.header-hide {
    z-index: 0;
  }

  .controls {
    margin: $f10px $f10px 0 $f10px;
    position: relative;
  }

  .control-link {
    position: absolute;
    float: left;
    left: 0;
    @media screen and (max-width: 768px) {
      position: static;
      margin-top: 5px;
    }
  }

  .control-link.link-2 {
    left: 103px
    margin-left: $f5px
    @media screen and (min-width: $large-responsive-size) {
      left: 5.2vmax
      left: 5.2vw
    }
  }

  .control-link.link-3 {
    right: 10px
    left: auto
    @media screen and (min-width: $large-responsive-size) {
      top: 0
      margin-left: $f5px
    }
  }

  .control-link.button.is-info.router-button {
    color: white;
  }

  .participa-help-panel {
    display: block;
    position: absolute;
    @media print {
      display: none;
    }
    @media screen and (min-width: 0) and (max-width: 790px) {
      display: none;
      opacity: 0;
    }
    @media screen and (min-width: 790px) and (max-width: 900px) {
      max-width: 22rem;
      left: calc(45% - 10rem);
    }
    @media screen and (min-width: 900px) and (max-width: 1200px) {
      max-width: 27rem;
      left: calc(40% - 10rem);
    }
    @media screen and (min-width: 1200px) and (max-width: 1450px) {
      max-width: 35rem;
      left: calc(44% - 15rem);
    }
    @media screen and (min-width: 1450px) {
      max-width: $help-panel-width;
      left: "calc(50% - %s)" % ($help-panel-width / 2);
    }
  }

  .summary-panel {
    position: fixed;
    bottom: $f70px;
    right: $f15px;
    @media screen and (max-height: 758px) {
      bottom: 9vmin;
      bottom: 9vh;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition-property: opacity max-height;
    transition-duration: 0.5s;
    max-height: 500px;
    will-change: opacity max-height;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
  }
}
</style>
